import { z } from 'zod';
import { emailSchema, passwordSchema } from '#app/schemas/shared/fieldSchemas/auth';
import { errorAuth, errorPassword } from '#app/schemas/shared/errorMessages';

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  captchaValue: z.string().optional(),
  form: z.string().optional(),
  code: z.string().optional(),
});

export const registerSchema = z
  .object({
    email: emailSchema,
    password: passwordSchema,
    /** Те же правила, что у `password` (длина и т.д.), плюс `.refine` на совпадение. */
    password_confirmation: passwordSchema,
    captchaValue: z.string().optional(),
    code: z.string().optional(),
    role: z.string().optional(),
    promo_code: z.string().optional(),
    form: z.string().optional(),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: errorPassword.match,
    path: ['password_confirmation'],
  });

export const registerCodeSchema = z.object({
  code: z.string({ error: errorAuth.code }).min(1, { message: errorAuth.code }),
});

/** То же правило, что поле `code` в registerCodeSchema (2FA / код в логине). */
export const authCodeFieldSchema = registerCodeSchema.shape.code;

/** Логин после ответа сервера о необходимости 2FA — поле `code` обязательно. */
export const loginSchemaWithTwoFactorCode = loginSchema.extend({
  code: authCodeFieldSchema,
});

export const forgotEmailSchema = z.object({
  email: emailSchema,
});

export const forgotCodeSchema = z
  .object({
    code: authCodeFieldSchema,
    password: passwordSchema,
    password_confirmation: passwordSchema,
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: errorPassword.match,
    path: ['password_confirmation'],
  });

export type LoginFormValues = z.infer<typeof loginSchema>;
export type RegisterFormValues = z.infer<typeof registerSchema>;
export type ForgotFormValues = z.infer<typeof forgotEmailSchema> & z.infer<typeof forgotCodeSchema>;
